import { z } from 'zod';

export const webhookEventSchema = z.enum([
  'send.queued',
  'send.sent',
  'send.delivered',
  'send.bounced',
  'send.opened',
  'send.clicked',
  'send.complained',
  'send.deferred',
  'send.failed',
  'template.published',
  'experiment.winner_declared',
]);

export const webhookEndpointSchema = z.object({
  id: z.string().uuid(),
  url: z.string().url(),
  description: z.string().nullable(),
  events: z.array(webhookEventSchema),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
});

export const createWebhookEndpointSchema = z.object({
  url: z.string().url(),
  description: z.string().max(200).optional(),
  events: z.array(webhookEventSchema).min(1),
});

export const webhookDeliverySchema = z.object({
  id: z.string().uuid(),
  eventType: webhookEventSchema,
  statusCode: z.number().int().nullable(),
  attempts: z.number().int(),
  deliveredAt: z.string().datetime().nullable(),
  errorMessage: z.string().nullable(),
  createdAt: z.string().datetime(),
});

export type WebhookEvent = z.infer<typeof webhookEventSchema>;
export type WebhookEndpoint = z.infer<typeof webhookEndpointSchema>;
export type CreateWebhookEndpointInput = z.infer<typeof createWebhookEndpointSchema>;
export type WebhookDelivery = z.infer<typeof webhookDeliverySchema>;
